﻿import { createWebHistory, createRouter } from "vue-router"
declare global { interface Window { dataLayer: any; } }

import { clarityTrack, claritySet } from "./clarity";

import NotFound from "../pages/NotFound.vue"

import Search from "../../tms/booking_engine/components/consumer/1_search.vue"
import Cart from "../../tms/booking_engine/components/consumer/3_cart.vue"
import Payment from "../../tms/booking_engine/components/consumer/4_check_out.vue"
import Credit_Card from "../../tms/booking_engine/components/consumer/4a_payment.vue"
import Pay_Link from "../../tms/booking_engine/components/consumer/4b_pay_link.vue"
import Link_Pay from "../../tms/booking_engine/components/consumer/4b_link_pay.vue"
import Confirmation from "../../tms/booking_engine/components/consumer/5_confirmation.vue"
import failed_payment from "../../tms/booking_engine/components/consumer/5b_failed.vue"

import store from "../../tms/booking_engine/store/index";

import UmbracoTourCalendar from "../../tms/booking_engine/components/consumer/2b_UmbracoTourCalendar.vue"

function getParamMetaTitle() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('open');
    const returnString = "Trips";
    if (myParam) {
        return returnString + " | " + myParam;
    }
    return returnString;
}

function getParamMetaDescription() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('open');
    const returnString = "" ;
    if (myParam) {
        returnString + "Calendar for tour: " + myParam;
    }
    else
    {
        returnString + "View our tours across scotland";
    }
    return returnString;
}

const history = createWebHistory();
const routes = [
    { path: "/", component: Search, name: "Search Screen", meta: { title: getParamMetaTitle(), description: getParamMetaDescription() }, alias: ["/book/:session_id"] },
    { path: "/cart", component: Cart, name: "Booking Cart", meta: { title: "Cart" }, alias: [ "/book/cart/:session_id"] },
    { path: "/payment", component: Payment, name: "Passenger Details", meta: { title: "Passenger Details" }, alias: ["/book/payment"] },
    { path: "/paylink", component: Pay_Link, name: "Payment Link", meta: { title: "Payment Link" }, alias: ["/book/paylink"] },
    { path: "/linkpay/:appid/:sessionid/:bookingid/:provider?", component: Link_Pay, name: "Payment Link", meta: { title: "Payment Link" } },
    { path: "/creditcard", component: Credit_Card, name: "Payment", meta: { title: "Payment" }, alias: ["/book/creditcard"] },
    { path: "/confirmation", component: Confirmation, name: "Confirmation", meta: { title: "Confirmation" }, alias: ["/book/confirmation"] },
    { path: "/failed_payment", component: failed_payment, name: 'failed_payment', meta: { title: "Payment failed" }, alias: ["/book/failed_payment"] },
    { path: "/:pathMatch(.*)*", component: NotFound, name: "Page Not Found", meta: { title: "Page Not Found" } }
]

const router = createRouter({
    history, routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            }
        }

        return { };
    }
});

router.beforeEach((to, from, next) => {
    window.document.title = String(to.meta.title) || "Unset Title";
    next();
});

const CLARITY_STEP_EVENTS: Record<string, string> = {
    "Search Screen": "view_search",
    "Booking Cart": "view_cart",
    "Passenger Details": "add_passenger_details",
    "Payment": "add_payment_info",
    "Payment Link": "add_payment_info",
    "Confirmation": "view_confirmation",
    "failed_payment": "payment_failed"
};

router.afterEach((to, from) => {
    if (from.matched.length === 0) {
        clarityTrack("begin_checkout");

        const tourId = to.query.open ?? to.query.tour_id;
        const departureDate = to.query.date ?? to.query.departure_date;
        if (tourId) claritySet("tour_id", String(tourId));
        if (departureDate) claritySet("departure_date", String(departureDate));
    }

    const stepEvent = CLARITY_STEP_EVENTS[String(to.name)];
    if (stepEvent) {
        clarityTrack(stepEvent);
    }
});

export default router;